
import React from "react";
import BusinessBasicInfo from "./profile/BusinessBasicInfo";
import BusinessDescription from "./profile/BusinessDescription";
import WebsiteAnalysisSection from "./profile/WebsiteAnalysisSection";
import BusinessDetails from "./profile/BusinessDetails";
import KeywordsDisplay from "./profile/KeywordsDisplay";
import { BusinessData } from "@/hooks/business/types";

interface BusinessProfileFormProps {
  businessData: BusinessData;
  updateBusinessData: (key: string, value: string | string[] | number | Record<string, string>) => void;
  updateMultipleFields?: (updates: Record<string, string | string[] | number | Record<string, string>>) => void;
}

const BusinessProfileForm = ({ 
  businessData, 
  updateBusinessData,
  updateMultipleFields
}: BusinessProfileFormProps) => {
  // Use business_tags for keywords if available
  const displayKeywords = businessData.businessTags?.length ? 
    businessData.businessTags : businessData.keywords;

  return (
    <div className="space-y-6">
      {/* Position the website analyzer prominently at the top with a different style */}
      <div className="bg-muted/30 p-4 rounded-lg border border-muted mb-8">
        <WebsiteAnalysisSection 
          website={businessData.website}
          lastAnalyzedAt={businessData.lastAnalyzedAt}
          updateBusinessData={updateBusinessData}
          updateMultipleFields={updateMultipleFields}
        />
      </div>
      
      <BusinessBasicInfo 
        name={businessData.name}
        industry={businessData.industry}
        industry_enum={businessData.industry_enum}
        updateBusinessData={updateBusinessData}
      />
      
      <BusinessDescription 
        description={businessData.description}
        updateBusinessData={updateBusinessData}
      />
      
      <BusinessDetails 
        companySize={businessData.companySize || ""}
        targetAudience={businessData.targetAudience || ""}
        updateBusinessData={updateBusinessData}
      />
      
      <KeywordsDisplay 
        keywords={displayKeywords || []} 
        updateBusinessData={(key, value) => {
          // Handle both keywords and businessTags
          if (key === "keywords" && businessData.businessTags?.length) {
            updateBusinessData("businessTags", value);
          } else {
            updateBusinessData(key, value);
          }
        }}
        isEditable={true}
      />
    </div>
  );
};

export default BusinessProfileForm;
